import * as React from "react";
import { InputGroup, Intent, MenuItem, Menu, Checkbox, NumericInput, SelectMenu, CustomLabel, ColorPicker, } from "@focus/focusUI";
import { GrafosSymbol, LineStyle } from "../interfaces/element";
import produce from "immer";
export const GrafosElementDialog = (props) => {
    const { content, onUpdate } = props;
    const [selected, setSelected] = React.useState(-1);
    const selectedElement = selected >= 0 && content.elements[selected];
    const updateColor = (color) => {
        const updatedContent = produce(content, (draft) => {
            const currentObject = draft.elements[selected];
            currentObject.symbolColor = color.hex;
        });
        onUpdate(updatedContent.elements);
    };
    const updatefield = (fieldName) => (event) => {
        const value = event.target ? event.target.value : event;
        const updatedContent = produce(content, (draft) => {
            const currentObject = draft.elements[selected];
            currentObject[fieldName] = value;
        });
        onUpdate(updatedContent.elements);
    };
    const yLabel = (selectedElement === null || selectedElement === void 0 ? void 0 : selectedElement.colY) ? "colY" : "colY2";
    return (React.createElement("div", { className: "focus-grafosConfig" },
        React.createElement("div", { className: "focus-grafosConfig_leftPanel" },
            React.createElement(CustomLabel, { text: "Element" },
                React.createElement(Menu, null, content.elements.map((_, index) => (React.createElement(MenuItem, { key: index, onClick: () => {
                        setSelected(index);
                    }, text: `Element_${index}`, active: selected === index })))))),
        React.createElement("div", null, selectedElement && (React.createElement(React.Fragment, null,
            React.createElement(CustomLabel, { text: "Title" },
                React.createElement(InputGroup, { intent: Intent.PRIMARY, onChange: updatefield("title"), value: selectedElement.title })),
            React.createElement(CustomLabel, { text: "colX" },
                React.createElement(InputGroup, { intent: Intent.PRIMARY, readOnly: true, onChange: updatefield("colX"), value: selectedElement.colX })),
            React.createElement(CustomLabel, { text: yLabel },
                React.createElement(InputGroup, { intent: Intent.PRIMARY, readOnly: true, onChange: updatefield(yLabel), value: selectedElement[yLabel] })),
            React.createElement(CustomLabel, { text: "Symbol" },
                React.createElement(SelectMenu, { options: Object.keys(GrafosSymbol), onChange: updatefield("symbol"), value: selectedElement.symbol })),
            React.createElement(CustomLabel, { text: "Line Style" },
                React.createElement(SelectMenu, { options: Object.keys(LineStyle), onChange: updatefield("lineStyle"), value: selectedElement.lineStyle })),
            React.createElement(CustomLabel, { text: "color" },
                React.createElement(ColorPicker, { onChange: updateColor, color: selectedElement.symbolColor })),
            React.createElement(CustomLabel, { text: "Fill Symbol" },
                React.createElement(Checkbox, { onChange: () => updatefield("fillSymbol")(!selectedElement.fillSymbol), checked: selectedElement.fillSymbol })),
            React.createElement(CustomLabel, { text: "Line Width" },
                React.createElement(NumericInput, { intent: Intent.PRIMARY, onValueChange: updatefield("lineWidth"), value: selectedElement.lineWidth })),
            React.createElement(CustomLabel, { text: "Symbol Size" },
                React.createElement(NumericInput, { intent: Intent.PRIMARY, onValueChange: updatefield("symbolSize"), value: selectedElement.symbolSize })))))));
};
//# sourceMappingURL=GrafosElementDialog.js.map